import { defineTranslateKeys } from 'lib/tolgee'

const TOLGEE_KEYS = defineTranslateKeys({
  successfullyEditedToast: ({ jobType, jobName }: { jobType: string; jobName: string }) => ({
    key: 'EditJobModal-successfullyEditedToast',
    parameters: {
      jobType,
      jobName,
      strong: <strong></strong>,
    },
    defaultValue: '{jobType} <strong>{jobName}</strong>  foi editado com sucesso!',
  }),
  successfullyRenamedToast: ({ jobType, jobName }: { jobType: string; jobName: string }) => ({
    key: 'EditJobModal-successfullyRenamedToast',
    parameters: {
      jobType,
      jobName,
      strong: <strong></strong>,
    },
    defaultValue: '{jobType} <strong>{jobName}</strong>  foi renomeado com sucesso!',
  }),
  modalTitle: ({ jobType }: { jobType: string }) => ({
    key: 'EditJobModal-title',
    parameters: {
      jobType,
    },
    defaultValue: 'Editar {jobType}',
  }),
  modalNameLabel: ({ jobType }: { jobType: string }) => ({
    key: 'EditJobModal-nameLabel',
    parameters: {
      jobType,
    },
    defaultValue: 'Nome do {jobType}',
  }),
  modalDescriptionLabel: ({ jobType }: { jobType: string }) => ({
    key: 'EditJobModal-descriptionLabel',
    parameters: {
      jobType,
    },
    defaultValue: 'Descrição do {jobType}',
  }),
})

export default TOLGEE_KEYS
